<template>
  <div class="item-floating-details">
    <div class="item-floating-details__body">
      <div class="item-floating-details__main">
        <div class="item-floating-details__top">
          <div class="base-tooltip">
            <div class="base-tooltip__activator tooltip-activator">
              <div :style="checkTradable(inventoryItem.tradable_after) ? 'color: #9a958b;':''">
                <div class="item-floating-730-label item-floating-details__label">
                  <span class="item-floating-730-label__small">
                    <div style="display: flex">
                      <div style="z-index: 999;flex: 1;white-space: nowrap;text-overflow: ellipsis;overflow: hidden">
                        {{
                          formatterLocalName(inventoryItem)
                        }}
                      </div>
                    </div>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <img :alt="inventoryItem.engName"
             data-type="SMG"
             :src="inventoryItem.icon_url"
             :style="checkAddable(inventoryItem)"
             class="item-floating-details__image">
        <div style="position: absolute;bottom: 60px;width: 100%;display: flex">
          <el-tag v-if="regexWear(inventoryItem.engName)" size="small" type="info" :style="formatterWear(inventoryItem)" style="opacity: 0.9">
            {{ $t(regexWear(inventoryItem.engName)) }}
          </el-tag>
        </div>
        <div class="item-details-row-light" style="height: 20px;margin-bottom: 8px;">
          <span class="item-details-row__label">
            <el-tag type="info" size="small">￥{{
                inventoryItem.minPrice == null ? '' : inventoryItem.minPrice.toFixed(2)
              }}
            </el-tag>
          </span>
          <span class="item-details-row__value">
            <el-tag v-if="inventoryItem.rarityName" size="small" type="info" style="float: right;max-width: 85px;"
                    :style="formatterRarity(inventoryItem.rarityName)">
              {{ formatterLocalRarityName(inventoryItem) }}
            </el-tag>
          </span>
        </div>
        <div v-if="inventoryItem.paint_wear" class="item-float item-card__float"
             :style="`--float-value:${inventoryItem.paint_wear * 100}%`"
             style="--float-background-color: #56524d;--float-range-start: 0%; --float-range-end: 100%;">
          <div data-v-2cf355cb="" class="item-float__bar"></div>
          <svg data-v-2cf355cb="" height="13" viewBox="0 0 20 13" width="20" class="item-float__indicator">
            <path data-v-2cf355cb=""
                  d="M4.5 7.115V2a2 2 0 012-2h7a2 2 0 012 2v5.115a2 2 0 01-.655 1.48L10 13 5.155 8.595a2 2 0 01-.655-1.48z"></path>
          </svg>
        </div>
        <div v-else style="height: 29px"></div>
        <div class="item-details-row-light" v-if="inventoryItem.paint_wear">
          <span class="item-details-row__label">{{ $t('paint_wear') }}</span>
          <span class="item-details-row__value">{{ inventoryItem.paint_wear.toFixed(11) }}</span>
        </div>
      </div>
    </div>
    <div style="text-align: center;font-size: 12px;margin-top: 8px;white-space: nowrap;text-overflow: ellipsis;overflow: hidden;height: 16px">
      {{ formatterLocalWeaponCaseName(inventoryItem.weaponCase) }}
    </div>
  </div>
</template>

<script>
import {formatterWear, rartiyIndex, regexWear} from "../../api/util";

export default {
  name: "inventoryItem",
  props: ['inventoryItem', 'weaponCasesIndex'],
  methods: {
    checkTradable(dateTimeString) {
      // 创建一个新的Date对象，传入给定的日期时间字符串
      var inputDate = new Date(dateTimeString);

      // 获取当前时间
      var currentDate = new Date();

      // 比较当前时间和给定的日期时间
      if (currentDate > inputDate || dateTimeString == null) {
        // 当前时间晚于给定的日期时间
        return false;
      } else {
        // 当前时间不晚于给定的日期时间
        return true;
      }
    },
    formatterDate(dateTimeString) {
      // 创建一个新的Date对象，传入日期时间字符串
      var date = new Date(dateTimeString);
      var localDate = date.toLocaleDateString();
      return localDate
    },
    formatterLocalRarityName(item) {
      let lang = localStorage.getItem("selectedLanguage")
      if (lang === 'zh') {
        return item.rarityName
      } else {
        return rartiyIndex[item.rarity]
      }
    },
    formatterLocalWeaponCaseName(val) {
      let lang = localStorage.getItem("selectedLanguage")
      if (lang === 'zh') {
        return val
      } else {
        return this.weaponCasesIndex[val] == null ? val : this.weaponCasesIndex[val]
      }
    },
    formatterRarity(val) {
      switch (val) {
        case '消费级':
          return 'color: #b0c3d9;'
        case '军规级':
          return 'color: #4b69ff;'
        case '受限':
          return 'color: #8847ff;'
        case '保密':
          return 'color: #d32ce6;'
        case '隐秘':
          return 'color: #eb4b4b;'
        case '违禁':
          return 'color: #e4ae39;'
        case '非凡':
          return 'color: #eb4b4b;'
        case '卓越':
          return 'color: #8847ff;'
        case '奇异':
          return 'color: #d32ce6;'
        case '高级':
          return 'color: #4b69ff;'
        case '普通级':
          return 'color: #b0c3d9;'
        case '不朽':
          return 'color: #F2B166;'
        case '至宝':
          return 'color: #9ACC4C;'
        case '神话':
          return 'color: #A876F9;'
        case '珍稀':
          return 'color: #7C8FF5;'
        case '罕见':
          return 'color: #82BDFF;'
        default:
          return ''
      }
    },
    calculateDisCount(item, val) {
      if (item.minPrice == null) {
        return null
      } else {
        return (item.minPrice / (val * 0.85)).toFixed(3)
      }
    },
    formatterLocalName(item) {
      let lang = localStorage.getItem("selectedLanguage")
      if (lang === 'en') {
        return item.engName
      } else {
        return item.cnName
      }
    },
    formatterWear(inventoryItem) {
      let wearArr = inventoryItem.engName.match(/\(([^)]*)\)/)
      if (wearArr != null && wearArr !== undefined && wearArr.length > 1) {
        return formatterWear(wearArr[1])
      } else {
        return ''
      }
    },
    regexWear(engName) {
      return regexWear(engName)
    },
    emitChangeCheckBox(val) {
      console.log(val)
    },
    removeParentheses(str) {
      let result = '';
      let openParenthesesCount = 0;

      for (let i = 0; i < str.length; i++) {
        if (str[i] === '(') {
          openParenthesesCount++;
        } else if (str[i] === ')' && openParenthesesCount > 0) {
          openParenthesesCount--;
        } else if (openParenthesesCount === 0) {
          result += str[i];
        }
      }

      return result;
    },
    formatterBackground(val) {
      switch (val) {
        case '隐秘':
          return 'color: rgb(235, 75, 75);'
        case '保密':
          return 'color: rgb(211, 44, 230);'
        case '受限':
          return 'color: rgb(136, 71, 255);'
        case '军规级':
          return 'color: rgb(75, 105, 255);'
        case '工业级':
          return 'color: rgb(94, 152, 217);'
        case '消费级':
          return 'color: rgb(176, 195, 217);'
        default:
          return ''
      }
    },
    checkAddable(inventoryItem) {
      if (inventoryItem.canTradeUp == null || inventoryItem.canTradeUp == false) {
        return "opacity: .3";
      }
      return ''
    }
  }
}
</script>

<style scoped>
.item-floating-details__body {
  background-color: rgb(233, 233, 235);
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, .1), 0 2px 4px -1px rgba(0, 0, 0, .06);
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  padding: 6px 8px;
}

.item-details-box {
  background-color: #302e2a;
  border-radius: 0.25rem;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, .05);
  font-size: .75rem;
  padding: 1rem;
  height: 100px;
}

.item-details-row__label {
  color: #aea89b;
  width: 65%;
}

.item-details-row__value {
  flex: 1;
  text-align: center;
}

.item-floating-details__image {
  height: 95px;
  margin: -0.5rem auto 0.5rem;
  -o-object-fit: scale-down;
  object-fit: scale-down;
  -o-object-position: center;
  object-position: center;
  pointer-events: none;
}

.item-floating-details__top {
  width: 100%;
}

.item-floating-details__main {
  display: flex;
  flex-direction: column;
  position: relative;
}

.item-details-paint {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.item-details-box {
  background-color: rgb(253, 246, 236);
  border-radius: 0.25rem;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, .05);
  font-size: .75rem;
  padding: 1rem;
}

.item-float {
  background-color: var(--float-background-color);
  display: flex;
  height: 4px;
  pointer-events: none;
  position: relative;
  width: 100%;
  z-index: 1;
  margin-bottom: 8px;
}

.item-float.large {
  margin-top: 4px;
}

.item-float.large .item-float.large .item-float__bar {
  border-radius: 2px;
  height: 6px;
}

.item-floating-details {
  margin: 8px;
  position: relative;
}

.item-float__bar {
  background: linear-gradient(90deg, #3b818f 0, #3b818f 7%, #83b135 0, #83b135 15%, #d7be47 0, #d7be47 38%, #f08140 0, #f08140 45%, #ec4f3d 0, #ec4f3d);
  -webkit-clip-path: polygon(var(--float-range-start) 0, var(--float-range-end) 0, var(--float-range-end) 100%, var(--float-range-start) 100%);
  clip-path: polygon(var(--float-range-start) 0, var(--float-range-end) 0, var(--float-range-end) 100%, var(--float-range-start) 100%);
  height: 4px;
  transition: opacity 275ms;
  width: 100%;
}

.item-details-row {
  display: flex;
  font-size: .875rem;
  justify-content: space-between;
}

.item-float__indicator {
  fill: deepskyblue;
  bottom: 4px;
  display: none;
  position: absolute;
  transition: opacity 275ms;
}

.item-float.large .item-float__indicator {
  display: block;
}

.item-floating-730-label {
  font-size: 12px;
  height: 24px;
  text-align: center;
}

.base-clipboard:hover {
  cursor: pointer;
}

.item-details-row-light {
  display: flex;
  height: 15px;
  text-align: left;
  font-size: 12px;
  align-items: center;
  margin-bottom: 2px;
}

.item-float__indicator {
  fill: #fff;
  bottom: 4px;
  display: none;
  left: -10px;
  margin-left: var(--float-value);
  position: absolute;
  transition: opacity 275ms;
}

.item-float__bar {
  background: linear-gradient(90deg, #3b818f 0, #3b818f 7%, #83b135 0, #83b135 15%, #d7be47 0, #d7be47 38%, #f08140 0, #f08140 45%, #ec4f3d 0, #ec4f3d);
  -webkit-clip-path: polygon(var(--float-range-start) 0, var(--float-range-end) 0, var(--float-range-end) 100%, var(--float-range-start) 100%);
  clip-path: polygon(var(--float-range-start) 0, var(--float-range-end) 0, var(--float-range-end) 100%, var(--float-range-start) 100%);
  height: 4px;
  transition: opacity 275ms;
  width: 100%;
}

.item-float:after {
  background-color: #fff;
  bottom: 0;
  content: "";
  height: 6px;
  left: min(var(--float-value), 100% - 1px);
  position: absolute;
  transition: opacity 275ms;
  width: 1px;
}
</style>



// WEBPACK FOOTER //
// src/ui/TradeUp/item.vue